import React from 'react';
import './Skills.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import SkillVector from '../../assets/skills_vector.png';
import { skillList } from '../../../src/profile';
import SkillItem from './SkillItems';

function Skills() {
  return (
    <div className="section-container fade-in">
      <Header
        heading="My Skills."
        details="Passionate about learning and engineering, I keep building. Here is the tech stack I have worked with."
      />

      <div className="skill-grid-wrapper">
        <div className="skill-card-container">
          {skillList.map(({ skillName, skillUrl }, index) => (
            <SkillItem 
              key={index} 
              skillName={skillName} 
              skillUrl={skillUrl} 
            />
          ))}
        </div>
      </div>

      <Footer
        title="Check out my 👉 "
        link="projects!"
        toAdress="/projects"
      />

      {/* Decorative background vectors (soft opacity) */}
      <div className="skills-vector-frame">
        <img
          src={SkillVector}
          alt=""
          className="skills-vector"
        />
      </div>
    </div>
  );
}

export default Skills;
